import { render, staticRenderFns } from "./dashCopyDialog.vue?vue&type=template&id=4fea3cf0&scoped=true"
import script from "./dashCopyDialog.vue?vue&type=script&lang=js"
export * from "./dashCopyDialog.vue?vue&type=script&lang=js"
import style0 from "./dashCopyDialog.vue?vue&type=style&index=0&id=4fea3cf0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fea3cf0",
  null
  
)

export default component.exports